<div class="layout-footer">
    <div class="footer-logo-container">
        <img [src]="'assets/layout/images/logo-' + logo + '.svg'" alt="diamond-layout"/>
        <span class="footer-app-name">WISE</span>
    </div>
    <span class="footer-copyright">&#169; Wise - 2023</span>
</div>
